export const defaultCarouselOptions = {
  type: "slide",
  effect: "flip",
  rewind: true,
  flipEffect: {
    slideShadows: false,
  },
  perPage: 5,
  perMove: 5,
  pagination: false,
  autoplay: false,
  breakpoints: {
    600: {
      perPage: 3,
      perMove: 3,
      gap: ".5rem",
    },
  },
};
